"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddonDropdown = void 0;
const react_1 = __importStar(require("react"));
const Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
const configContext_1 = require("../../context/configContext");
const BookingItem_1 = require("../../models/BookingItem");
const IconAddCircleOutline_1 = require("../icons/IconAddCircleOutline");
const AddonSelectModal_1 = require("./AddonSelectModal");
const AddonDropdown = (props) => {
    var _a, _b;
    const [modal, setModal] = (0, react_1.useState)();
    function showModal(newModal) {
        setModal(newModal);
    }
    function hideModal() {
        setModal(undefined);
    }
    const config = (0, configContext_1.useConfig)();
    function handleAddonSelected(configAddon) {
        const newAddon = new BookingItem_1.BookingItem(config, configAddon);
        newAddon.quantity = 1;
        newAddon.updatePriceAndUnit(props.booking.isFullDay());
        props.onNewAddon(newAddon);
        hideModal();
    }
    function handleCustomAddonSelected(type) {
        const newAddon = new BookingItem_1.BookingItem(config);
        newAddon.type = type;
        newAddon.quantity = 1;
        newAddon.unit = "Stück";
        props.onNewAddon(newAddon);
        hideModal();
    }
    const dropdownItems = [];
    const addonsByType = (_a = props.booking.configResource) === null || _a === void 0 ? void 0 : _a.getAddonsGroupedByType({
        includeHidden: true,
    });
    for (let type in addonsByType) {
        dropdownItems.push(react_1.default.createElement(Dropdown_1.default.Item, { key: type, onClick: () => showModal(react_1.default.createElement(AddonSelectModal_1.AddonSelectModal, { type: type, configAddons: addonsByType[type], onClose: hideModal, onAddonSelected: handleAddonSelected, onCustomAddonSelected: () => {
                    handleCustomAddonSelected(type);
                } })) }, type));
    }
    if (dropdownItems.length > 0) {
        dropdownItems.push(react_1.default.createElement(Dropdown_1.default.Divider, { key: "misc-divider" }));
    }
    // Miscellaneous addon type.
    dropdownItems.push(react_1.default.createElement(Dropdown_1.default.Item, { key: config.miscAddonType, onClick: () => handleCustomAddonSelected(config.miscAddonType) }, config.miscAddonType));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown_1.default, { className: "addon-dropdown " + ((_b = props.className) !== null && _b !== void 0 ? _b : "") },
            react_1.default.createElement(Dropdown_1.default.Toggle, { variant: "light", size: "sm", id: "addon-dropdown" },
                react_1.default.createElement(IconAddCircleOutline_1.IconAddCircleOutline, null),
                " Artikel hinzuf\u00FCgen\u00A0"),
            react_1.default.createElement(Dropdown_1.default.Menu, null, dropdownItems)),
        modal));
};
exports.AddonDropdown = AddonDropdown;
